import { render } from "./tickets-filter.vue?vue&type=template&id=37f5aa79"
import script from "./tickets-filter.vue?vue&type=script&lang=js"
export * from "./tickets-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__